import styled from 'styled-components';

export const ConfiguracaoNFeForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .MuiInputBase-root {
    margin: 8px 0;
    height: 40px;
  }
  .MuiInputBase-input {
    padding: 10px 14px;
    font-size: 14px;
  }
  .MuiFormLabel-root {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .MuiFormControl-root {
    width: 100%;
    margin-bottom: 8px;
  }
  .MuiOutlinedInput-root {
    height: 40px;
  }
  div[class*="sel__control"] {
    min-height: 40px !important;
    height: 40px !important;
    margin: 8px 0 !important;
  }
  div[class*="sel__value-container"] {
    padding: 2px 8px !important;
    font-size: 14px !important;
    height: 38px !important;
  }
  div[class*="sel__input"] {
    font-size: 14px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  div[class*="sel__placeholder"] {
    font-size: 14px !important;
  }
`;

export const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 0;
  .MuiInputBase-root {
    margin: 8px 0;
    height: 40px;
  }
  .MuiInputBase-input {
    padding: 10px 14px;
    font-size: 14px;
  }
  .MuiFormLabel-root {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .MuiFormControl-root {
    width: 100%;
    margin-bottom: 8px;
  }
  .MuiOutlinedInput-root {
    height: 40px;
  }
  div[class*="sel__control"] {
    min-height: 40px !important;
    height: 40px !important;
    margin: 8px 0 !important;
  }
  div[class*="sel__value-container"] {
    padding: 2px 8px !important;
    font-size: 14px !important;
    height: 38px !important;
  }
  div[class*="sel__input"] {
    font-size: 14px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  div[class*="sel__placeholder"] {
    font-size: 14px !important;
  }
`;

export const SectionTitle = styled.h2`
  color: #42b5f5;
  font-weight: bold;
  font-size: 20px;
  margin: 0 0 15px 0;
`;

export const BuscarArquivo = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const StatusIndicator = styled.div<{ color: string }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  display: inline-block;
  margin-left: 10px;
`;

export const StyledDatePicker = styled.div`
  .MuiInputBase-root {
    height: 40px !important;
    margin: 8px 0 !important;
  }
  .MuiInputBase-input {
    padding: 10px 14px !important;
    font-size: 14px !important;
  }
  .MuiFormLabel-root {
    font-size: 14px !important;
  }
`;

export const StyledSelectWrapper = styled.div`
  width: 100%;
  margin: 8px 0;
  div[class*="sel__control"] {
    min-height: 40px !important;
    height: 40px !important;
  }
  div[class*="sel__value-container"] {
    padding: 2px 8px !important;
    font-size: 14px !important;
    height: 38px !important;
  }
  div[class*="sel__input"] {
    font-size: 14px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  div[class*="sel__placeholder"] {
    font-size: 14px !important;
  }
`;

